module.exports = __webpack_public_path__ + "static/media/wx_search.3cdd1d08.png";